import { render, staticRenderFns } from "./ViewerColorPicker.vue?vue&type=template&id=6cfb883a&scoped=true"
import script from "./ViewerColorPicker.vue?vue&type=script&lang=js"
export * from "./ViewerColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ViewerColorPicker.vue?vue&type=style&index=0&id=6cfb883a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb883a",
  null
  
)

export default component.exports